import { ESaleType } from 'packages/api-models/common/json_query';
import { getTermsValue, setTerms } from './helpers';
import { TJsonQuery, NonEmptyArray } from './types';
import { FLAT_OLD_SALE_TYPES } from 'shared/constants/saleTypeValues';
import { setSaleTypes } from './setSaleTypes';

export const setFlatOldSaleTypes = (jsonQuery: TJsonQuery) => (nextSaleTypes: NonEmptyArray<ESaleType> | null) => {
  const prevSaleTypes = getTermsValue('sost_type')(jsonQuery);

  if (prevSaleTypes && nextSaleTypes === null) {
    const filteredSaleTypes = prevSaleTypes.filter(saleType => !FLAT_OLD_SALE_TYPES.includes(saleType));

    return setTerms('sost_type')(jsonQuery)(filteredSaleTypes);
  }

  return setSaleTypes(jsonQuery)(nextSaleTypes);
};
